export enum FormTakePayment {
  YES = 'Yes',
  NO = 'No',
}
